import { StorageService } from './storage.service';
import _ from 'lodash';

const KEY = 'wishlist';

function addToWishlist(product, qiuckAdd, quant) {
    let wishlist = StorageService.load(KEY)


    for (let i = 0; i < wishlist.length; i++) {
        if (_.isEqual(wishlist[i], product)) {
            
            wishlist[i].quantity = quant
            StorageService.save(KEY, wishlist)
            return JSON.parse(JSON.stringify(product.product || product))
                }
    }

    if (!product.size || qiuckAdd) {
        product.size = 36
    } else {
        product.product.size = JSON.parse(product.size)
    }

    if (!wishlist) {
        StorageService.save(KEY, [product.product || product])
        return (JSON.parse(JSON.stringify(product.product || product)))
    }

    wishlist.unshift(product.product || product)
    StorageService.save(KEY, wishlist)
    return JSON.parse(JSON.stringify(product.product || product))
}

function removeFromWishlist(product) {
    let wishlist = StorageService.load(KEY)

    if (wishlist[product.id]) {
        if (wishlist[product.id].quantity > 1) wishlist[product.id].quantity -= 1
    }

   let newWishlist = wishlist.filter(wishlistItem => {
        return product.id !== wishlistItem.id
    })
    newWishlist = JSON.parse(JSON.stringify(newWishlist));
    StorageService.save(KEY, newWishlist)
    return product
}

function loadWishlist() {
    let wishlist = StorageService.load(KEY)
    if (!wishlist) {
        StorageService.save(KEY, [])
        wishlist = []
    }
    return wishlist
}

export const WishlistService = {
    addToWishlist,
    loadWishlist,
    removeFromWishlist,
}